<template lang="pug">
  div
    v-card(class="mb-12" height="auto")
      v-layout(row wrap)
        v-flex(xs4 sm3 style="margin-top:12px")
          p(class="headerSection") 
            span(class="mustFill") *
            span  Judul Usulan
        v-flex(xs7 sm5 )
          v-text-field(style="margin-top:10px" class="inputDefault"  label="Judul Usulan" v-model="dataSubmitPerubahan.ipJudulPekerjaan")
        v-flex(xs1 sm4)

        v-flex(xs4 sm3) 
          p(class="headerSection") 
            span(class="mustFill") *
            span  Tanggal 
        v-flex(xs4 sm3)
          v-menu(
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px")
        
            template(v-slot:activator="{ on }")
              v-text-field(
                v-model="dataSubmitPerubahan.ipTanggalPerubahan"
                label="Tanggal"
                prepend-icon="event"
                readonly
                v-on="on")
            v-date-picker(v-model="dataSubmitPerubahan.ipTanggalPerubahan" @input="clearDate")
        v-flex(xs1 sm4)

        //- v-flex(xs4 sm3 style="margin-top:20px")
        //-   p(class="headerSection") 
        //-     span(class="mustFill") *
        //-     span  Pengaju
        //- v-flex(xs7 sm5 style="margin-top:15px")
        //-   v-text-field(class="inputDefault" label="Pengaju" v-model="dataSubmitPerubahan.ipPemegangIzin.name" filled disabled)
        //- v-flex(xs1 sm4)

        v-flex(xs4 sm3) 
          p(class="headerSection") 
            span(class="mustFill") *
            span  Department / Divisi
        v-flex(xs7 sm5)
          v-row
            v-col
              v-autocomplete(
                 class="inputDefault"
                 v-model="dataSubmitPerubahan.ipDeptDivisi"
                 :items="dataUsers.department"
                 label="Department")
            v-col
              v-text-field(class="inputDefault" v-model="dataSubmitPerubahan.ipDivisi" counter="100" maxlength="100" label="Divisi")
        v-flex(xs1 sm4)
        
        v-flex(xs4 sm3) 
          p(class="headerSection") 
            span(class="mustFill") *
            span  Perusahaan
        v-flex(xs7 sm5)
              v-autocomplete(
                 class="inputDefault"
                 v-model="dataSubmitPerubahan.ipPerusahaan"
                 :items="dataUsers.companies"
                 label="Perusahaan")
        v-flex(xs1 sm4)

        v-flex(xs4 sm3)
          p(class="headerSection") 
            span(class="mustFill") *
            span  Jabatan
        v-flex(xs7 sm5)
          v-text-field(class="inputDefault" label="Jabatan" v-model="dataSubmitPerubahan.ipJabatan")
        v-flex(xs1 sm4)

    v-btn(text class="mr-3"  @click="backHome()") Cancel
    v-btn(color="primary" @click="nextStep(2); scrollTop();" :disabled='!isPageComplete') Continue
      
</template>

<script>
import { mapState } from "vuex";
import PemegangModal from "../PemegangModal.vue";
export default {
  name: "DetailUsulan",
  components: {
    PemegangModal
  },
  props: ["e1","dataSubmitPerubahan"],
  data() {
    return {
      judulUsulan: "",
      startDate: "",
      atasan:'',
      startMenu: false,
      searchPemegangMenu: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers"]),
    isPageComplete: function () {
      return (
        !!this.dataSubmitPerubahan.ipJudulPekerjaan &&
        !!this.dataSubmitPerubahan.ipTanggalPerubahan &&
        !!this.dataSubmitPerubahan.ipPemegangIzin.name &&
        !!this.dataSubmitPerubahan.ipDeptDivisi &&
        !!this.dataSubmitPerubahan.ipDivisi &&
        !!this.dataSubmitPerubahan.ipPerusahaan &&
        !!this.dataSubmitPerubahan.ipJabatan
      );
    },
  },
  methods: {
    // updateAtasan(user) {
    //   this.dataSubmitPerubahan.ipAtasan = {
    //     waNotif: 1,
    //     position: user.position,
    //     phone: user.contact,
    //     email: user.email,
    //     name: user.name,
    //     nik: user.nik
    //   };
    // },
    clearDate() {
      this.startMenu = false;
    },
    nextStep(val){
        this.$emit("continueBtn", val);
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    scrollTop(){
      window.scrollTo(0,0);
    },
  },
  watch: {},
};
</script>

<style></style>
